<template>
  <div style="padding: 30px 10px; font-size: 14px">
    <div style="margin: 10px 0"> {{ $t("footer.exchange") }}</div>
    <div>
      <van-row style="padding: 7px;">
        <van-col :span="6">{{ $t('option.time') }}</van-col>
        <van-col :span="4" style="text-align: center">{{ $t('tradelst.tab1') }}</van-col>
        <van-col :span="6" style="text-align: center">{{ $t('option.price2') }}</van-col>
        <van-col :span="8" style="text-align: right">{{ $t('option.num') }}</van-col>
      </van-row>
      <div  v-if="list && list.length > 0" :class="
                parseFloat(safeSymbol.close) > parseFloat(safeSymbol.open) ? 'data-up' : 'data-down'
              ">
      <van-row v-for="(item,index) in list" :key="index" style="padding: 7px;">
        <van-col :span="6">{{ new Date(item.ts).toLocaleString().split(' ')[1] }}</van-col>
        <van-col :span="4" style="text-align: center">{{ item.direction }}</van-col>
        <van-col :span="6" style="text-align: center">{{ item.price }}</van-col>
        <van-col :span="8" style="text-align: right">{{ parseFloat(item.amount).toFixed(6) }}</van-col>
      </van-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteRecord',
  props: ['symbol'],
  computed: {
    safeSymbol () {
      return this.symbol || null
    }
  },
  data () {
    return {
      timer: null,
      list: null
    }
  },
  mounted () {
    const that = this;
    this.$nextTick(() => {
      that.timer = setInterval(() => {
        that.getData()
      }, 5000)
    })
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    async getData () {
      if(!(this.safeSymbol && this.safeSymbol.symbol)){
        return
      }
      await this.$http({
        method: 'post',
        url: 'getHuoBiAllTradeFromRedis',
        data: {
          symbol: this.safeSymbol.symbol
        }
      }).then(res => {
        this.list = res.data
      })
    }
  }
}
</script>

<style></style>
